import React from "react";
import { AskButton } from "../AskButton/AskButton";
import styles from "./AskanexpertStyles.module.css";
import { BASE_URL, CURRENT_ROLE } from "../../API/url";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export const AskAnExpert = () => {
  const state = useSelector((state) => state?.user);
  const location = useLocation();
 
  // const isId4Present = data.some(item => item.id === 4);
  const check = state?.roles
    ?.filter((item) => item.roleName === "Seeker")
    .map((item) => {
      let val = item?.permissions;
      return val.some(item => item.id === 4);
    });
    // console.log("chck",check)

  const isDisabled =  check[0];
// console.log("isDisabled that",isDisabled)
  return (
    <div className={`${styles.askAnExpertRow} row`} style={{}} role="button">
      <div className="col-md-12 text-center">
        <span>
          <i
            className="fa fa-lightbulb-o"
            style={{
              color: "#fd7401",
              paddingRight: "5px",
              fontSize: "20px",
            }}
          ></i>{" "}
          {CURRENT_ROLE === "Seeker"
            ? "Not satisfied with the suggestions? Please submit your question to experts:"
            : "Not Satisfied? Add an answer to this question yourself!"}{" "}
        </span>
        <AskButton isDisabled={!isDisabled}/>
      </div>
    </div>
  );
};
